import getCurrentPath from '@nicolaudie-group/ng-ui-kit/helpers/getCurrentPath'
import useUserStore from '@/stores/user.store'

function useLogin() {
  const userStore = useUserStore()

  function login() {
    return userStore.goToLogin({ goto: getCurrentPath() })
  }

  return login
}

export default useLogin
